import { AnyAction } from 'redux';
import {
	FETCH_PROFILE_FAILURE,
	FETCH_PROFILE_IN_PROGRESS,
	FETCH_PROFILE_SUCCESS,
	LOGOUT_USER,
	LOG_USER_FAILURE,
	LOG_USER_IN_PROGRESS,
	LOG_USER_SUCCESS,
	SWITCH_TO_BACKOFFICE_SUCCESS,
	USER_UPDATE_TOKENS,
} from 'redux/actions/mobivers';
import {UserState, mapProdukteToSalesType, SalesType} from '../../types/redux';

const USER_STATUS_UNDEFINED = 'undefined';
const USER_STATUS_PROFILE_UNDEFINED = 'USER_STATUS_PROFILE_UNDEFINED';
export const USER_STATUS_PROFILE_LOADING = 'USER_STATUS_PROFILE_LOADING';
const USER_STATUS_PROFILE_FINISHED = 'USER_STATUS_PROFILE_FINISHED';
export const USER_STATUS_LOGIN_IN_PROGRESS = 'login_in_progress';
export const USER_STATUS_LOGIN_FAILED = 'login_failed';
export const USER_STATUS_LOGIN_BAD_CREDENTIALS = 'login_bad_credentials';
export const USER_STATUS_LOGIN_SUCCESS = 'login_success';

const initialState: UserState = {
	status: USER_STATUS_UNDEFINED,
	profileStatus: USER_STATUS_PROFILE_UNDEFINED,
	name: '',
	email: '',
	company: '',
	access_token: '',
	refresh_token: '',
	salesType: [],
	switchedToBackoffice: false,
};

export function userReducer(
	state: UserState = initialState,
	action: AnyAction
): UserState {
	switch (action.type) {
		case LOG_USER_IN_PROGRESS:
			return {
				...state,
				email: action.payload.email,
				status: USER_STATUS_LOGIN_IN_PROGRESS,
			};
		case LOG_USER_SUCCESS:
			return {
				...state,
				access_token: action.payload.access_token,
				refresh_token: action.payload.refresh_token,
				status: USER_STATUS_LOGIN_SUCCESS,
			};
		case USER_UPDATE_TOKENS:
			return {
				...state,
				access_token: action.payload.access_token,
				refresh_token: action.payload.refresh_token,
			};
		case LOG_USER_FAILURE:
			if (action.payload.message === 'bad_credentials') {
				return { ...state, status: USER_STATUS_LOGIN_BAD_CREDENTIALS };
			}

			return { ...state, status: USER_STATUS_LOGIN_FAILED };
		case LOGOUT_USER:
			return initialState;
		case FETCH_PROFILE_IN_PROGRESS:
			return {
				...state,
				profileStatus: USER_STATUS_PROFILE_LOADING,
			};
		case FETCH_PROFILE_SUCCESS:
			const userSalesTypes:SalesType[] = mapProdukteToSalesType( action.payload.produkte);
			return {
				...state,
				name: `${action.payload.vorname} ${action.payload.nachname}`,
				salesType: userSalesTypes,
				company: action.payload.autohaus,
				profileStatus: USER_STATUS_PROFILE_FINISHED,
			};
		case FETCH_PROFILE_FAILURE:
			return {
				...state,
				profileStatus: USER_STATUS_PROFILE_FINISHED,
			};
		case SWITCH_TO_BACKOFFICE_SUCCESS:
			return {
				...initialState,
				switchedToBackoffice: true,
			};
		default:
			return state;
	}
}
